<template>
  <div class="assignment-stripe">
    <Reference />
    <CompanyInfo />
    <div class="d-flex pr-4 assignment-stripe-status">
      <AssignmentStatus :assignment="assignment" :error-count="errorCount" />
    </div>

    <Downloads />
    <FeaturesCell :assignment="assignment" :staff-icons="false" />
    <LastEdited />
    <PricingLink />
  </div>
</template>

<script lang="ts">
import type { Assignment, StatusType } from '@/types/Models/Assignment'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { pluralize } from '@/services/Helpers'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import Status from '@/views/Components/Assignment/Cells/Status.vue'
import Downloads from '@/views/Components/Assignment/Stripe/Downloads.vue'
import Reference from '@/views/Components/Assignment/Stripe/Reference.vue'
import LastEdited from '@/views/Components/Assignment/Stripe/LastEdited.vue'
import CompanyInfo from '@/views/Components/Assignment/Stripe/Company.vue'
import PricingLink from '@/views/Components/Assignment/Stripe/PricingLink.vue'
import FeaturesCell from '@/views/Components/Assignment/Cells/Features.vue'

export default defineComponent({
  name: 'AssignmentStripe',
  components: {
    FeaturesCell,
    CompanyInfo,
    PricingLink,
    LastEdited,
    Downloads,
    Reference,
    AssignmentStatus: Status,
  },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)
    const assignmentStatus: ComputedRef<StatusType> = computed(() => assignment.value.status)
    const errorCount: ComputedRef<number> = computed(
      () => assignment.value.internationalErrorsCount + assignment.value.domesticErrorsCount,
    )

    return {
      assignment,
      assignmentStatus,
      errorCount,
      pluralize,
    }
  },
})
</script>
